<template>
  <div>
    <div v-if="apiUser" class="d-flex justify-content-center flex-wrap">
      <div class="mb-2 mx-2 layout__boxWrapper">
        <div class="layout__box admin-page__box">
          <ResellerMenu />
        </div>
      </div>
      <div class="mb-2 mx-2 layout__boxWrapper">
        <div class="layout__box admin-page__box">
          <CustomerMenu />
        </div>
      </div>
      <div class="mb-2 mx-2 layout__boxWrapper">
        <div class="layout__box admin-page__box">
          <ProjectMenu @open-new="toggleNewModal('newProject')" />
        </div>
      </div>
    </div>

    <div v-if="openedNew.length > 0">
      <div>
        <ProjectNew
          :opened="openedNew"
          @close-box="toggleNewModal"
          @open-box="toggleNewModal"
          @reload-projects="reloadProjects"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomerMenu from "@/components/admin/customer/menu.vue"
import ProjectMenu from "@/components/admin/project/menu.vue"
import ResellerMenu from "@/components/admin/admin/menu.vue"
import ProjectNew from "@/components/modals/admin/project/newProject.vue"
import { useCustomerStore } from "@/store/modules/customer"
import { useProjectStore } from "@/store/modules/project"
import { useAuthStore } from "@/store/modules/auth"

export default {
  components: {
    CustomerMenu,
    ProjectMenu,
    ResellerMenu,
    ProjectNew
  },
  setup() {
    const customerStore = useCustomerStore()
    const projectStore = useProjectStore()
    const authStore = useAuthStore()

    return {
      customerStore,
      projectStore,
      authStore
    }
  },
  data() {
    return {
      openedNew: []
    }
  },
  computed: {
    customers() {
      return this.customerStore.customerList
    },
    projects() {
      return this.projectStore.projectList
    },
    user() {
      return this.authStore.user
    },
    apiUser() {
      return this.authStore.apiUser
    }
  },
  watch: {},
  mounted() {
    if (this.$route.query.createProject) {
      this.toggleNewModal("newProject")
    }
  },
  methods: {
    toggleNewModal(box) {
      if (this.openedNew.indexOf(box) > -1) {
        if (box === undefined) {
          this.openedNew = []
        } else {
          const tmp = this.openedNew
          tmp.splice(this.openedNew.indexOf(box), 1)
          this.openedNew = tmp
        }
      } else {
        this.openedNew = this.openedNew.concat(box)
      }
    },
    reloadProjects() {
      this.projectStore.getProjectList()
    }
  }
}
</script>

<style lang="scss" scoped></style>
